import { render, staticRenderFns } from "./du-process.vue?vue&type=template&id=3472b2aa&"
import script from "./du-process.vue?vue&type=script&lang=js&"
export * from "./du-process.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports